<app-header></app-header>
<div style='height: 100px; background: #EEEEEE 0% 0% no-repeat padding-box;' class='border-4 border-bottom'>
  <div class="row">
    <div class="col-md-12">
      <h2 class="text-center pt-4">
        <span class="font-color-navy welcome-text pt-4">My Requests</span>
      </h2>
    </div>
  </div>
</div>
<br />
<div class="container-fluid font-color-navy container-shadow">
  <div id="detailledInformationTabs" class="detailledInformationTabs">
    <ul style="padding: 0px 0px;">     
      <li [ngClass]="currentTab == '/openrequests' ? 'col-md-6 ui-tabs-active' : 'col-md-6 ui-tabs-inactive'">
        <a (click)="onNavigate('openrequests')">Open Requests<span *ngIf="activeRequestCount>-1">({{activeRequestCount}})</span></a>
       <span class="glyphicon glyphicon-refresh"></span>
      </li>
      <li [ngClass]="currentTab == '/closedrequests' ? 'col-md-6 ui-tabs-active' : 'col-md-6 ui-tabs-inactive'"><a (click)="onNavigate('closedrequests')">Closed Requests</a></li>
    </ul>
  </div> 
</div>


